<template>
  <div>
    <section class="content-header">
      <h1>{{ item && item['name'] }}</h1>
    </section>

      <section class="content">
        <div class="box box-primary">
          <div class="box-body">
      <item-show-errors :entity="'product'" :is-loading="isLoading"></item-show-errors>

            <div v-if="item" class="table-responsive">
              <table class="table table-striped table-hover">
                <thead>
                <tr>
                  <th width="20%">{{$t('field')}}</th>
                  <th>{{$t('value')}}</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>{{$t('product.company.code')}}</td>
                  <td>
                    <router-link :to="{name: 'CompanyShow', params: { id: item.company['@id'] }}" v-if="item.company">
                      {{ item.company.code}}
                    </router-link>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('product.id')}}</td>
                  <td>{{ item['id'] }}</td>
                </tr>
                <tr>
                  <td>{{$t('product.name')}}</td>
                  <td>{{ item.name }}</td>
                </tr>
                <tr>
                  <td>{{$t('product.machineType')}}</td>
                  <td v-if="item.category">
                    <router-link :to="{name: 'CategoryShow', params: { id: item.category['@id'] }}" v-if="item.company">
                      {{ translation(item.category).name}}
                    </router-link>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('product.age')}}</td>
                  <td>{{ item['age'] }}</td>
                </tr>
                <tr>
                  <td>{{$t('product.priceBuy')}}</td>
                  <td>
                    <template v-if="item.currencyBuy">
                      {{ item['priceBuy'] }} {{ item['currencyBuy']['code'] }}
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('product.incotermBuy')}}</td>
                  <td>
                    <template v-if="item.incotermBuy">
                      {{ item['incotermBuy']['name'] }}
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('product.priceSell')}}</td>
                  <td>
                    <template v-if="item.currencySell">
                      {{ item['priceSell'] }} {{ item['currencySell']['code'] }}
                    </template>
                  </td>
                </tr>
<!--                <tr>-->
<!--                  <td>{{$t('product.priceOldSell')}}</td>-->
<!--                  <td>-->
<!--                    <template v-if="item.currencySell">-->
<!--                      {{ item['priceOldSell'] }} {{ item['currencySell']['code'] }}-->
<!--                    </template>-->
<!--                  </td>-->
<!--                </tr>-->
                <tr>
                  <td>{{$t('product.incotermSell')}}</td>
                  <td>
                    <template v-if="item.incotermSell">
                      {{ item['incotermSell']['name'] }}
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('product.transport')}}</td>
                  <td>
                    <template v-if="item.transport">
                      {{ item.transport }}
                    </template>
                  </td>
                </tr>
                <tr>
                  <td>{{$t('product.availability')}}</td>
                  <td>{{ item['availability'] }}</td>
                </tr>
<!--                <tr>-->
<!--                  <td>{{$t('product.isSold')}}</td>-->
<!--                  <td>{{ item.isSold ? $t('yes') : $t('no') }}</td>-->
<!--                </tr>-->

                <tr>
                  <td>{{$t('product.status.id')}}</td>
                  <td>
                    <template v-if="item.status">
                      {{ item.status.name}}
                    </template>
                  </td>
                </tr>

                <tr>
                  <td>{{$t('product.priceOnRequest')}}</td>
                  <td>{{ item.priceOnRequest ? $t('yes') : $t('no') }}</td>
                </tr>


                <tr>
                  <td>{{$t('product.condition')}}</td>
                  <td>{{ translation(item.condition).name}}</td>
                </tr>
                <tr>
                    <td>{{$t('product.maxSize')}}</td>
                    <td>{{ item['maxSize'] }}</td>
                </tr>
                <tr>
                    <td>{{$t('product.impressCount')}}</td>
                    <td>{{ item['impressCount'] }}</td>
                </tr>
                <tr>
                    <td>{{$t('product.colors')}}</td>
                    <td>{{ item['colors'] }}</td>
                </tr>
                <tr>
                    <td>{{$t('product.extras')}}</td>
                    <td>{{ item['extras'] }}</td>
                </tr>
                <tr>
                  <td>{{$t('product.video')}}</td>
                  <td><a target="_blank" :href="item['video']" v-if="item['video']">{{ item['video'] }}</a></td>
                </tr>
                <tr>
                  <td>{{$t('product.description')}}</td>
                  <td>{{ translation(item).description }}</td>
                </tr>
                <tr>
                  <td>{{$t('product.createdAt')}}</td>
                  <td>{{ moment(item['createdAt']).format('DD-MM-YYYY HH:mm') }}</td>
                </tr>
                <tr>
                  <td>{{$t('product.updatedAt')}}</td>
                  <td>{{ moment(item['updatedAt']).format('DD-MM-YYYY HH:mm') }}</td>
                </tr>
                <tr>
                  <td>{{$t('product.updatedBy')}}</td>
                  <td>{{ item['updatedBy'] }}</td>
                </tr>
                <tr>
                    <td>{{$t('product.isActive')}}</td>
                    <td>{{ item.isActive ? $t('yes') : $t('no') }}</td>
                </tr>
                <tr>
                  <td>{{$t('product.images')}}</td>
                  <td>
                    <template v-for="image in item.images">
                      <img :src="imagePath(image, '200')" class="wp-post-image" alt="">
                    </template>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
            </div>
            </div>

        <div class="container-fluid hidden-print">
          <div class="row">
            <div class="col-md-6">
            </div>
            <div class="col-md-6">
              <div class="pull-right">
                <button type="button" class="btn btn-warning" @click="createEmailTemplate(item)" v-if="isGranted('ROLE_COMPANY_SHOW')">Create email template</button>
                <button type="button" class="btn btn-info" @click="generatePdf(item)" v-if="isGranted('ROLE_COMPANY_SHOW')">{{$t('generate_pdf')}}</button>
                <button type="button" class="btn btn-success" @click="backToList(item)" v-if="isGranted('ROLE_COMPANY_LIST')">{{$t('back_to_list')}}</button>
                <button type="button" class="btn btn-primary" @click="editItem(item)" v-if="isGranted('ROLE_COMPANY_UPDATE')">{{$t('edit')}}</button>
                <button type="button" class="btn btn-danger" @click="deleteItem(item)" v-if="isGranted('ROLE_COMPANY_DELETE')">{{$t('delete')}}</button>
              </div>
            </div>
          </div>
        </div>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ItemShowActions from '../layout/ItemShowActions'
import ItemShowErrors from '../layout/errors/ItemShowErrors'
import Image from '../../mixin/Image.vue'
import axios from '../../interceptor'

export default {
  mixins: [Image],

  components: {
    ItemShowErrors,
    ItemShowActions
  },
  data () {
    return {
      moment: moment
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'product/show/isLoading',
      item: 'product/show/retrieved',
    })
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      reset: 'product/show/reset',
      retrieve: 'product/show/retrieve',
    }),
    generatePdf (item) {
      axios.request({
        url: process.env.API_URL + '/products/' + item.id + '/pdf',
        method: 'GET',
        responseType: 'blob', // important
      }).then(response => {
        this.$toastr.s(this.$t('pdf_successfully_generated'))

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', item.id + '.pdf');
        document.body.appendChild(link);
        link.click();
      }).catch(() => {
        this.$toastr.e(this.$t('pdf_generate_error'))
      })
    },
    createEmailTemplate (item) {
      if  (confirm('Do you really want to create email template for Unisender?')) {
        axios.request({
          url: process.env.API_URL + '/products/' + item.id + '/template',
          method: 'GET',
        }).then(response => {
          this.$toastr.s('Email template successfully created')
        }).catch(() => {
          this.$toastr.e(this.$t('Unable to generate email template'))
        })
      }
    },
    backToList (item) {
      this.$router.push({ name: 'ProductList' })
    },
    editItem (item) {
      this.$router.push({ name: 'ProductUpdate', params: { id: this.item['@id'] } })
    },
    deleteItem (item) {
      if (window.confirm(this.$t('delete_are_you_sure'))) {
        this.$store.dispatch('product/del/del', item)
          .then(() => this.$router.push({ name: 'ProductList' }))
      }
    }
  }
}
</script>
